<template>
  <div style="background-color:#e5e5f7;height:120%;width:100%;position:relative">
    <div class="w">
      <div class="head">
        <el-row class="clearfix">
          <div class="match1 fl" >
            <!-- <img src="../assets/match.png" alt=""> -->
          </div>
          <div class="fl pointer colorf">
            <span @click="toHome">首页</span>
          </div>
          <div class="fr pointer">
            <el-dropdown @command="handleCommand">
              <span class="el-icon-user-solid colorc loginInfo"></span>
              <div style="display: inline-block;margin-left: 10px;font-size: 20px;color: #fff;">{{maUser.realName}}</div>
              <el-dropdown-menu slot="dropdown" style="margin-top:-10px;">
                <el-dropdown-item command="a" @click="logOut" style="width:2rem;text-align:center">退出登录</el-dropdown-item>
                <el-dropdown-item    @click.native="revise" style="width:2rem;text-align:center">修改密码</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            
          </div>
        </el-row>
      </div>
    </div>

    <div class="formBox pc">
      <div class="form">
        <div class="title">提交作品</div>
        <el-form label-width="3rem">
          <el-form-item label="作品名称">
            <el-input type="text" placeholder="请输入作品名称" v-model="sendData.opusName"></el-input>
          </el-form-item>
          <el-form-item label="作品介绍">
            <el-input type="textarea" placeholder="请输入作品介绍" resize="none" v-model="sendData.opusIntroduction"></el-input>
          </el-form-item>
          <el-form-item label="作品上传">
            <el-upload
              class="upload-demo"
              :action='$tool.upload.file(sendData.scheduleId)'
              :on-remove="removeFile"
              :before-upload="beforeUpload"
              :before-remove="beforeRemove"
              :limit="1"
              :on-success='onFileSuccess'
              :file-list="fileList_A"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>

          <div style="margin-left:2rem;" class="clearfix">
            <el-button style="width:40%;background-color:#fff;color:#000;border-color:#ccc" class="fl" @click="_back">返回</el-button>
            <el-button style="width:40%;background-color:#120fb7;color:#fff" class="fr" @click="_submit">提交</el-button>
          </div>
        </el-form>
      </div>
    </div>

    <div class="imgBox mobile">
            <img src="../assets/123-.png" alt="" style='width:400px;'>
            <p style="text-align:center">快去电脑上提交或完善您的作品吧~</p>
    </div>  


  </div>
</template>

<script>
import { submitOp, getTools } from '@/api/index'
export default {
  data () {
    return {
      duration:0,
      options: [],
      fileList_A: [],
      fileList_B: [],
      fileList_C: [],
      toolsList: [],
      maUser:{
        realName:""
      },
      sendData: {
        scheduleId: this.$route.query.id,
        opusName: '',
        opusIntroduction: '',
        opusPath: '',
        opusPathName: '',
        videoPath: '',
        videoPathName: '',
        attachmentPath: '',
        attachmentPathName: '',
        advisorMobile:'',
        advisor: '11',
        tools: '源码熊'
      },
      otherTool: '',
      flag: true
    }
  },
  created () {
    if (!this.$route.query.id) {
      this.$router.push({
        name: 'home'
      })
    }
    this._getTools()
    //关闭弹窗
    // this.$alert('<p style="margin-bottom: 10px;text-indent: 2em;text-align: justify;">根据赛事规定，参赛作品需上传作品推荐表、作品说明、解说视频等资料，请在提交前下载下方附件，并按实际情况认真填写，打包作为附件一并上传。如不上传，将影响后续晋级情况。</p>附件：<a href="https://dy-static.oss-cn-beijing.aliyuncs.com/xxbc/%E9%99%84%E4%BB%B61%E4%BD%9C%E5%93%81%E6%8E%A8%E8%8D%90%E8%A1%A8.docx" style="margin-bottom: 5px;">1、作品推荐表.docx</a><a href="https://dy-static.oss-cn-beijing.aliyuncs.com/xxbc/%E9%99%84%E4%BB%B62%E4%BD%9C%E5%93%81%E5%88%9B%E4%BD%9C%E8%AF%B4%E6%98%8E.docx" style="display: block; margin-bottom: 5px;text-indent: 3em;">2、作品创作说明.docx</a><a href="https://dy-static.oss-cn-beijing.aliyuncs.com/xxbc/%E9%99%84%E4%BB%B63%E6%95%B0%E5%AD%97%E5%88%9B%E4%BD%9C-%E8%AE%A1%E7%AE%97%E6%80%9D%E7%BB%B4%E8%AF%84%E6%AF%94%E9%A1%B9%E7%9B%AEtemplate110.xlsx" style="display: block;text-indent: 3em;">3、数字创作-计算思维评比项目template110.xlsx</a>  ', '郑重提醒', {
    //       confirmButtonText: '我已知晓',
    //       showClose:false,
    //       dangerouslyUseHTMLString: true
    //     });
  },
  mounted () {this.maUser.realName = this.$tool.sessionGet('maUser').realName},
  methods: {
    revise () {
      this.$router.push({
        name:'revisePassword'
      })
    },
    removeFile (file, fileList) {
      this.sendData.opusPath = ''
      this.sendData.opusPathName = ''
    },
    removeMovie (file, fileList) {
      this.sendData.videoPath = ''
      this.sendData.videoPathName = ''
    },
    removeFile2 (file, fileList) {
      this.sendData.attachmentPath = ''
      this.sendData.attachmentPathName = ''
    },
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    beforeUpload (file) {
      this.flag = false
    },
    beforeUploadZip(file){
      const { name, size } = file;

      const index = name.lastIndexOf('.');
      // 判断文件名是否有后缀，没后缀文件错误
      if(index === -1) {
          this.$message({
            message: '请上传压缩格式文件（*.zip,*.rar）',
            type: 'warning'
          })
          return false;
      }
      const fileType = name.substr(index + 1);
      const acceptFileTypes = ['zip', 'rar'];
      // 判断文件类型
      if(!acceptFileTypes.includes(fileType)) {
              this.$message({
          message: '请上传压缩格式文件（*.zip,*.rar）',
          type: 'warning'
        })
        return false;
      }
      //判断是否符合文件大小的限制需求
      const isLt2M = file.size / 1024 / 1024 < 700
      if (!isLt2M) {
        this.$message({
          message: `上传文件大小不能超过700M!`,
          type: 'warning'
        })
        debugger
        return false
      }       
    },
    beforeUploadVideo (file) {
      // 判断是否符合文件大小的限制需求
      const isLt2M = file.size / 1024 / 1024 < 700
      // 判断是否符合文件类型需求
      const isLtType = ["video/mp4", "video/ogg", "video/flv", "video/avi", "video/wmv", "video/rmvb", "video/mov"]
      if (!isLt2M) {
        this.$message({
          message: `上传文件大小不能超过700M!`,
          type: 'warning'
        })
        debugger
        return false
      }
      let correctType = true
      //限制视频格式
      // if(isLtType.indexOf(file.type) == -1){
      //   correctType = false
      //   this.$message({
      //     message: '请上传视频格式文件',
      //     type: 'warning'
      //   })
      //   return false
      // }else{
      //   correctType = true
      // }
      correctType = true
      this.flag = true
      debugger
      return isLt2M && correctType //返回false或者reject状态的promise则停止上传
    },
    async _getTools () {
      const res = await getTools()
      if (res.code !== 200) return this.$tool.messageError(res.message)
      this.toolsList = res.result
    },
    onFileSuccess (res, file, fileList) {
      if (res.code !== 200) return this.$tool.messageError(res.message)
      this.sendData.opusPath = res.result
      this.sendData.opusPathName = file.name
      this.flag = true
    },
    onMovieSuccess (res, file, fileList) {
      if (res.code !== 200) return this.$tool.messageError(res.message)
      this.sendData.videoPath = res.result
      this.sendData.videoPathName = file.name
      this.flag = true
    },
    onFile2Success (res, file, fileList) {
      if (res.code !== 200) return this.$tool.messageError(res.message)
      this.sendData.attachmentPath = res.result
      this.sendData.attachmentPathName = file.name
      this.flag = true
    },
    toPage (e) {
      if (e === 1) {
        window.location.href = 'http://dianyixueyuan.com'
      } else if (e === 2) {
        window.location.href = 'http://www.yuanmaxiong.cn'
      } else if (e === 3) {
        window.location.href = 'https://ymjs.dianyixueyuan.com'
      }
    },
    _back () {
      this.$confirm(`未提交的数据将无法保存，是否返回`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'constyle'
      }).then(() => {
        this.$router.push({
          name: 'cards'
        })
      }).catch(() => {
      })
    },
    async _submit () {
      if (!this.flag) return this.$tool.message('请等待文件上传完成')
      let send = this.$tool.obCopy(this.sendData)


      if (!send.opusName){
        return this.$tool.messageError('请填写作品名称')
      }

      // if (!send.opusIntroduction){
      //   return this.$tool.messageError('请填写作品介绍')
      // }

      // if (!send.advisor){
      //   return this.$tool.messageError('请填写指导老师')
      // }

      // if (!send.advisorMobile){
      //   return this.$tool.messageError('请填写指导老师联系方式')
      // }

      // if (!send.videoPath){
      //   return this.$tool.messageError('请上传视频')
      // }

      // if (!send.attachmentPath){
      //   return this.$tool.messageError('请上传附件')
      // }


      if (!send.opusPath) return this.$tool.messageError('请上传作品')
      if (send.tools === '其他') {
        send.tools = this.otherTool
      }
      if (!send.tools) return this.$tool.messageError('请输入工具名称')

      this.$confirm('是否确认提交作品', '提示', {
        confirmButtonText: '确认提交',
        cancelButtonText: '再想想',
        type: 'warning',
        customClass: 'constyle'
      }).then(() => {
        submitOp(send).then(res => {
          if (res.code !== 200) return this.$tool.messageError(res.message)
          this.$tool.messageSuccess('提交成功')
          return this.$router.push({
            name: 'cards'
          })
        })
      }).catch(() => {
      })
    },
    logOut () {
      this.$tool.sessionRem('userType')
      this.$tool.sessionRem('maUser')
      this.$tool.sessionRem('accessToken')
      this.$router.push({
        name: 'home'
      })
    },
    handleCommand (command) {
      if (command === 'a') {
        this.$tool.sessionRem('userType')
        this.$tool.sessionRem('maUser')
        this.$tool.sessionRem('accessToken')
        this.$router.push({
          name: 'home'
        })
      }
    },
    toHome () {
      this.$router.push({
        name: 'home'
      })
    }
  }
}
</script>

<style lang="scss" scoped>

  .pc {
    display: none;
  }
  .mobile {
    display: block;
  }
  @media (min-width: 768px) {
    .pc {
      display: block;
    }
    .mobile {
    display: none;
  }
  }
  .imgBox{
    text-align: center;
    width: 400px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
  .match1 {
    margin-left: 1.4rem;
    margin-right: 1.7rem;
    position: relative;
    top: -6px;
    img{
      position: relative;
      top: 15px;
      left: 0;
    }
  }
.w {
  width: 100%;
  background:linear-gradient(0deg,rgba(66,111,255,1),rgba(88,167,255,1));
  height: 1.5rem;
  .apply {
    padding: 0.1rem 0.3rem;
    margin-right: 0.2rem;
    border: 1px solid #ccc;
    border-radius: 30px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  }
  .loginInfo {
    padding: 0.1rem 0.1rem;
    background-color: #fff;
    border-radius: 100%;
    font-size: 0.5rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  }
  .head {
    width: 70%;
    margin: 0 auto 20px;
    height: 100%;
    line-height: 1.5rem;
  }
}
.otherTool{
  width: 1.5rem;
  border: 0;
  outline: none;
  background-color: rgba(0, 0, 0, 0);
  border-bottom: 1px solid #ccc;
  margin-left: -2px;
}
::v-deep .el-cascader {
  width: 100%;
}
::v-deep  .el-radio-group{
  padding-left: 10px;
}
::v-deep  .el-radio{
  margin-left: -10px;
}
.formBox {
  width: 20.4rem;
  height: 16.9rem;
  background-color: #fff;
  margin: 20px auto 100px;
  border-radius: 8px;
  .form {
    width: 10.32rem;
    height: 10.64rem;
    padding-top:44px;
    // border: 1px solid #ccc;
    /*position: absolute;*/
    /*left: 50%;*/
    /*top: 50%;*/
    margin: 40px auto 0;
    .title {
      padding: 0.4rem 0;
      text-align: center;
      font-size: 0.4rem;
    }
  }
}
.footer_wrapper{
  background: url('../assets/footer.png') no-repeat;
  background-size: cover;
  height: 208px;
  /*height: 182px;*/
  padding-top: 36px;
  box-sizing: border-box;
  /*position: absolute;*/
  /*bottom: 0;*/
  /*left: 0;*/
  width: 100%;
  .foot{
    display: flex;
    box-sizing: border-box;
    .zw{
      flex: 1;
    }
    .link{
      flex: 3;
      color: #fff;
      position: relative;
      margin-left: 20px;
      text-shadow:0px 1px 2px rgba(0, 0, 0, 0.45);
      .box{
        position: absolute;
        left: 0;
        .top{
          display: flex;
          margin-bottom: 1.1rem;
          span{
            flex: 1;
            text-align: left;
            color: #fff;
            cursor: pointer;
            font-size: 28px;
          }
        }
        .box_info{
          font-size: 25px;
        }
      }
    }
    .qrcode{
      flex: 2;
      box-sizing: border-box;
      padding-left: 40px;
      img{
        width: 28%;
      }
      img:nth-child(1){
        margin-left: 0.8rem;
        margin-right: 1.2rem;
      }
    }
  }
  .intro{
    width: 100%;
    flex: 1;
  }
  .w{
    width: 70%;
    margin: 0 auto;
    .apply{
      padding: 0.1rem 0.3rem;
      margin-right: 0.2rem;
      border:1px solid #ccc;
      border-radius: 30px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    }
    .loginInfo{
      padding: 0.1rem 0.1rem;
      background-color: #fff;
      border-radius: 100%;
      font-size: 0.5rem;
      box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    }
  }
}
</style>
